import Axios from "axios";

const AUTH_DICTIONARIES = import.meta.env.VITE_AUTH_DICTIONARIES;

export function UpdateCountryService(data, token,id) {
  return new Promise(async (resolve, reject) => {
    try {
      console.log(data);
      const response = await Axios.put(
        `${AUTH_DICTIONARIES}/api/locations/v1/countries/${id}`,
        data,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          }
        }
      );
      console.log(response);
      resolve(response);
    } catch (error) {
      reject(error);
      console.log(error);
    }
  });
}